import { useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Verified from "../../../images/Verified-Partner.png";
import notVerified from "../../../images/notVerified.jpeg";
import {
  getTeamPanDocuments,
  getTeamAddharDocuments,
} from "../../../redux/viewPartnerDocuments/action";
import { connect } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import useSession from "../../CustomLogout/useSession";
import UiButton from "../../Common/UiButton/UiButton";
import { Spin, message, notification } from "antd";
import { saveTeamsPanDetails } from "../../../redux/TeamPanVerification/action";

const TeamDetailsTabs = ({
  teamDetails,
  getTeamPanDocuments,
  accessToken,
  getTeamAddharDocuments,
  showDrawer,
  setShow,
  saveTeamsPanDetails,
  state,
  getAll,
}) => {
  const location = useLocation();
  const id = location?.state?.partnerFirmId;
  const handleSessionExpired = useSession();

  const [disable, setDisable] = useState(false);

  function getPanData(personID) {
    getTeamPanDocuments({ accessToken, personID }).then((res) => {
      showDrawer();
      setShow("TeamPan");
    });
  }

  function getAddharData(personID) {
    getTeamAddharDocuments({ accessToken, personID }).then((res) => {
      showDrawer();
      setShow("TeamAddhar");
    });
  }

  const panTrigger = (personId, panNo) => {
    setDisable(true);
    const panTeamsVerificationData = {
      partnerPersonId: personId,
      partnerFirmId: id,
      partnerTeamPanNumber: panNo,
      partnerTeamPanConsent: true,
    };

    saveTeamsPanDetails({
      values: panTeamsVerificationData,
      access_token: accessToken,
      // partnerFirmId: props.firmId,
    }).then((res) => {
      if (res && res.status === 200) {
        message.success("Saved");
        setDisable(false);
        getAll();
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        setDisable(false);

        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          setDisable(false);

          handleSessionExpired();
        } else {
          setDisable(false);
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      } else {
        setDisable(false);
      }
    });
  };

  const [branchId, setBranchId] = useState(1);
  console.log("line 100", disable);
  return (
    <div className="inner-Tab-sec-edit-pat">
      <Tab.Container id="left-tabs-example" defaultActiveKey={branchId}>
        <Row>
          <Col sm={2} className="left-side-tabs branchScroll">
            <Nav variant="pills" className="flex-column">
              {teamDetails?.length > 0
                ? teamDetails.map((branch, index) => {
                    return (
                      <Nav.Item onClick={() => setBranchId(index + 1)}>
                        <Nav.Link eventKey={index + 1}>
                          <div className="tab-selet-test">
                            <h4>{branch.personFullName}</h4>
                          </div>
                        </Nav.Link>
                      </Nav.Item>
                    );
                  })
                : ""}

              {/* // <Nav.Item>
              //   <Nav.Link eventKey="second">
              //     {" "}
              //     <div className="tab-selet-test">
              //       <h4>
              //         Mrs. Seema  <br></br>Agarwal
              //       </h4>
              //     </div>
              //   </Nav.Link>
              // </Nav.Item>
              // <Nav.Item>

              // </Nav.Item> */}
            </Nav>
          </Col>
          <Col sm={10}>
            <Tab.Content>
              {teamDetails?.length > 0
                ? teamDetails.map((branch, index) => {
                    const branchAdress = branch?.currentAddressDTO?.address;
                    const branchFullAddress = `${
                      branchAdress?.addressLine1 ?? ""
                    } ${branchAdress?.addressLine2 ?? ""} ${
                      branchAdress?.landmark ?? ""
                    } ${branchAdress?.cityName ?? ""} ${
                      branchAdress?.stateName ?? ""
                    } ${branchAdress?.countryName ?? ""} ${
                      branchAdress?.pincode ?? ""
                    }`;

                    const branchAdressPer =
                      branch?.permanentAddressDTO?.address;
                    const branchFullAddressPer = `${
                      branchAdressPer?.addressLine1 ?? ""
                    } ${branchAdressPer?.addressLine2 ?? ""} ${
                      branchAdressPer?.landmark ?? ""
                    } ${branchAdressPer?.cityName ?? ""} ${
                      branchAdressPer?.stateName ?? ""
                    } ${branchAdressPer?.countryName ?? ""} ${
                      branchAdressPer?.pincode ?? ""
                    }`;

                    const mobileNos =
                      branch.currentAddressDTO?.mobileNumbers?.length > 0
                        ? branch?.currentAddressDTO?.mobileNumbers
                            ?.map((mobileNo) => mobileNo)
                            .join(", ")
                        : "";

                    const phoneNos =
                      branch.currentAddressDTO?.mobileNumbers?.length > 0
                        ? branch?.currentAddressDTO?.phoneNumbers
                            ?.map((mobileNo) => mobileNo)
                            .join(", ")
                        : "";

                    const mobileNosPer =
                      branch?.permanentAddressDTO?.mobileNumbers?.length > 0
                        ? branch?.permanentAddressDTO?.mobileNumbers
                            ?.map((mobileNo) => mobileNo)
                            .join(", ")
                        : "";

                    const phoneNosPer =
                      branch?.permanentAddressDTO?.mobileNumbers?.length > 0
                        ? branch?.permanentAddressDTO?.phoneNumbers
                            ?.map((mobileNo) => mobileNo)
                            .join(", ")
                        : "";

                    return (
                      <Tab.Pane eventKey={index + 1}>
                        <Row>
                          <Col
                            lg={12}
                            xs={12}
                            md={12}
                            sm={12}
                            className="ineer-ed-text tabs-sec"
                          >
                            <Col md={6} className="">
                              <div className="text-content-ed">
                                <h5>Current Address Details</h5>
                                <h2>
                                  {branchFullAddress}
                                  <br></br>
                                  {branch?.currentAddressDTO?.officeOwnership
                                    ?.name !== undefined &&
                                  branch?.currentAddressDTO?.officeInLocality
                                    ?.name !== undefined
                                    ? `${branch?.currentAddressDTO?.officeOwnership?.name}  | ${branch?.currentAddressDTO?.officeInLocality?.name} |${branchAdress?.yearsAtCurrentAddress}`
                                    : ""}
                                </h2>
                              </div>
                            </Col>
                            <Col md={6} className="">
                              <div className="text-content-ed">
                                <h5>Contact Details </h5>
                                <h2>
                                  {`${mobileNos} ,${phoneNos}
                          `}
                                  <br></br>
                                  {branch?.currentAddressDTO?.emailAddress}
                                </h2>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={12}
                            xs={12}
                            md={12}
                            sm={12}
                            className="ineer-ed-text tabs-sec"
                          >
                            <Col md={6} className="">
                              <div className="text-content-ed">
                                <h5>Permanent Address Details</h5>
                                {branch?.permanentAddressDTO?.address ==
                                null ? (
                                  <div>Same as current address</div>
                                ) : (
                                  <h2>{branchFullAddressPer}</h2>
                                )}
                              </div>
                            </Col>
                            <Col md={6} className="">
                              <div className="text-content-ed">
                                <h5>Contact Details </h5>
                                <h2>
                                  {`${mobileNosPer} ,${phoneNosPer}
                          `}
                                  <br></br>
                                  {branch?.permanentAddressDTO?.emailAddress}
                                </h2>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                        <Row>
                          {/* <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="ineer-ed-text tabs-sec mob-text-pn-add"
                        >
                          <Col md={6} className="">
                            <div
                              className="text-content-ed"
                              style={{
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <h5>AAdhaar</h5>
                              {branch?.partnerTeamAadhaarDetailsDTO
                                ?.partnerTeamAadhaarConsent ? (
                                <>
                                  <div className="pan-ver pan-jshgf-text">
                                    <div>
                                      <h2>
                                        {
                                          branch?.partnerTeamAadhaarDetailsDTO
                                            ?.partnerTeamAadhaarNumber
                                        }
                                      </h2>

                                      <div
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          getAddharData(
                                            branch.partnerPersonId
                                          );
                                        }}
                                      >
                                        <b style={{ color: "blue" }}>
                                          View Response
                                        </b>
                                      </div>
                                    </div>
                                    <img src={Verified} alt="" />
                                  </div>
                                </>
                              ) : (
                                <div className="pan-ver">
                                  <h2>No Aadhaar data</h2>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Col> */}
                          <Col
                            lg={12}
                            xs={12}
                            md={12}
                            sm={12}
                            className="ineer-ed-text tabs-sec"
                          >
                            <Col md={6} className="">
                              <div className="text-content-ed">
                                <h5>Pan</h5>

                                {branch?.partnerTeamPanDetailsDTO
                                  ?.isVerified ? (
                                  <>
                                    <div className="pan-ver pan-jshgf-text">
                                      <div>
                                        <h2>
                                          {
                                            branch?.partnerTeamPanDetailsDTO
                                              ?.partnerTeamPanNumber
                                          }
                                        </h2>
                                        {state?.userData?.loggedInRoleType !==
                                        "PARTNER" ? (
                                          <div
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              getPanData(
                                                branch.partnerPersonId
                                              );
                                            }}
                                          >
                                            <b style={{ color: "blue" }}>
                                              View Response
                                            </b>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </div>

                                      <img src={Verified} alt="" />
                                    </div>
                                    {state?.userData?.loggedInRoleType !==
                                    "PARTNER" ? (
                                      branch?.partnerTeamPanDetailsDTO
                                        ?.isPanMatchedWithName ? (
                                        <p
                                          className="panteam-match-text"
                                          style={{
                                            color: "green",
                                            marginLeft: "2vw",
                                          }}
                                        >
                                          Pan Matched with the name
                                        </p>
                                      ) : (
                                        <p
                                          className="panteam-match-text-red"
                                          style={{ color: "red" }}
                                        >
                                          Pan doesn't match with the name
                                        </p>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (state?.userData?.loggedInRoleType ===
                                    "CET" ||
                                    state?.userData?.loggedInRoleType ===
                                      "RM" ||
                                    state?.userData?.loggedInRoleType ===
                                      "PARTNER") &&
                                  branch?.partnerTeamPanDetailsDTO
                                    ?.partnerTeamPanNumber ? (
                                  <div>
                                    <p>
                                      {
                                        branch?.partnerTeamPanDetailsDTO
                                          ?.partnerTeamPanNumber
                                      }
                                    </p>
                                    <img
                                      className="notverified"
                                      src={notVerified}
                                    />
                                    <div>
                                      {branch?.partnerTeamPanDetailsDTO
                                        ?.partnerTeamPanNumber ? (
                                        state?.userData?.loggedInRoleType ===
                                          "CET" && (
                                          <UiButton
                                            disable={disable}
                                            onClick={() =>
                                              panTrigger(
                                                branch?.partnerPersonId,
                                                branch?.partnerTeamPanDetailsDTO
                                                  ?.partnerTeamPanNumber
                                              )
                                            }
                                            type="submit"
                                            title="retrigger"
                                          />
                                        )
                                      ) : (
                                        <b>No data</b>
                                      )}
                                      {disable && <Spin />}
                                    </div>
                                  </div>
                                ) : (
                                  <b>No data</b>
                                )}
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      </Tab.Pane>
                    );
                  })
                : " "}

              {/* <Tab.Pane eventKey="third">  <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="ineer-ed-text tabs-sec"
                >
                  <Col md={6} className="">
                    <div className="text-content-ed">
                      <h5>Address Details</h5>
                      <h2>
                        1 Anand Nagar, Opp Ramdevpir Mandir,<br></br>
                        Chandlodiar, Gandhi Nagar<br></br>
                        Ahmedabad - 382481, Gujarat<br></br>
                        <br></br>
                        Rented | Commerical | 5.2 yeas
                      </h2>
                    </div>
                  </Col>
                  <Col md={6} className="">
                    <div className="text-content-ed">
                      <h5>Contact Details </h5>
                      <h2>
                        Samsher Singh 8393740441, 8030484088<br></br>
                        info_mumbai@excelpartner.com
                      </h2>
                    </div>
                  </Col>
                </Col>
              </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className=""></Col>
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Gst Details </h5>

                        <div className="pan-ver">
                          <h2> 27AAJDHEURB37</h2>
                          <img src={Verified} alt="" />
                        </div>
                      </div>
                    </Col>
                  </Col>
                </Row></Tab.Pane> */}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    accessToken: state?.auth?.idToken,
    DocData: state?.PanDocs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTeamPanDocuments: (data) => dispatch(getTeamPanDocuments(data)),
    getTeamAddharDocuments: (data) => dispatch(getTeamAddharDocuments(data)),
    saveTeamsPanDetails: (data) => dispatch(saveTeamsPanDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamDetailsTabs);
